import { useAppContext } from "../../contexts/AppContext";
import { sidebarItems } from "./data";
import { Sidebar, SidebarProps } from "../../components/layout/Sidebar";


export const CustomSidebar = ({
    isOpen,
    isCollapsed,
    navbarProps,
    onClose,
    onToggleText
}:SidebarProps) => {

    const context = useAppContext();
    
    // create onClick events from handleClick, pipeline and chat
    sidebarItems.map(item => {
        if(item.handleClick || item.pipeline || item.chat) {
            let callback = item.handleClick;
            item.onClick = (event : React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {

                if(item.pipeline) {
                    context.setSelectedPipeline(item.pipeline);
                }
                
                if(item.chat) {
                    context.setSelectedChat(item.chat);
                }
                
                if(callback) {
                    callback(event);
                }
            }
        }

        if(item.subSection) {
            item.subSection.map(subitem => {
                let callback = subitem.handleClick;
                if(subitem.handleClick || subitem.pipeline || subitem.chat) {
                    subitem.onClick = (event : React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        
                        if(subitem.pipeline) {
                            context.setSelectedPipeline(subitem.pipeline);
                        }
                        
                        if(subitem.chat) {
                            context.setSelectedChat(subitem.chat);
                        }
                        
                        if(callback) {
                            callback(event);
                        }
                    }
                }
            });
        }

    });
    
    return (
        <>
            
            {context?.showSidebar? 
                    <Sidebar 
                        isOpen={isOpen}
                        isCollapsed={isCollapsed}
                        navbarProps={navbarProps}
                        onClose={onClose}
                        onToggleText={onToggleText}
                    />
                :
                <></>
            }
                
        </>
    );
}
